import { getElementSize, getWindowSize } from '../../utils/dom';
const padding = 8;
const paddings = padding * 2;
export const offset = {
    name: 'offset',
    options: {
        offset: [0, padding],
    },
};
export const overflow = (container) => ({
    name: 'preventOverflow',
    options: {
        boundary: container,
    },
});
export const noflip = { name: 'flip', enabled: false };
export const dimensions = (container) => ({
    name: 'calculateDimensions',
    enabled: true,
    phase: 'beforeRead',
    fn({ state }) {
        const controlEl = state.elements.reference;
        const contentEl = state.elements.popper;
        const containerIsBody = container === document.body;
        const box = containerIsBody ? getWindowSize() : getElementSize(container);
        const origin = getElementSize(document.body);
        const control = getElementSize(controlEl);
        const content = getElementSize(contentEl);
        const cbottom = control.bottom - origin.top;
        const ctop = control.top - origin.top;
        const ymax = box.bottom - origin.top;
        const ymin = box.top - origin.top;
        const result = state.modifiersData.dimensions || {};
        result.cbottom = cbottom;
        result.ctop = ctop;
        result.ymin = ymin;
        result.ymax = ymax;
        result.contentHeight = result.contentHeight || content.height;
        state.modifiersData.dimensions = result;
    },
});
export const fit = {
    name: 'calculateFit',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateDimensions'],
    fn({ state }) {
        const { ctop, ymin, cbottom, contentHeight, ymax } = state.modifiersData.dimensions;
        const up = ctop - paddings - contentHeight >= ymin;
        const down = cbottom + paddings + contentHeight <= ymax;
        const availableTopSpace = ctop - ymin;
        const availableBottomSpace = ymax - cbottom;
        const result = state.modifiersData.fit || { availableSpaces: {} };
        const adaptivePlacement = !!state.modifiersData.adpApplyDirection;
        let initial = 'none';
        if (up) {
            initial = 'top';
        }
        if (down) {
            initial = 'bottom';
        }
        result.initial = initial;
        result.adjusted = !adaptivePlacement || availableBottomSpace >= availableTopSpace ? 'bottom' : 'top';
        result.availableSpaces.top = availableTopSpace - paddings;
        result.availableSpaces.bottom = availableBottomSpace - paddings;
        state.modifiersData.fit = result;
    },
};
export const adpApplyDirection = (container, positioning) => ({
    name: 'adpApplyDirection',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateFit'],
    fn({ state }) {
        const box = container ? getElementSize(container) : getWindowSize();
        const origin = getElementSize(document.body);
        const control = getElementSize(state.elements.reference);
        const content = getElementSize(state.elements.popper);
        const cbottom = control.bottom - origin.top;
        const ymax = box.bottom - origin.top;
        const down = cbottom + padding + content.height <= ymax;
        const placement = down ? 'bottom' : 'top';
        state.placement = `${placement}-${positioning}`;
    },
});
export const adhApplyDirection = (positioning) => ({
    name: 'adhApplyDirection',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateFit'],
    fn({ state }) {
        const { initial, adjusted } = state.modifiersData.fit;
        if (initial !== 'none') {
            return;
        }
        state.placement = `${adjusted}-${positioning}`;
    },
});
export const applyHeight = {
    name: 'applyHeight',
    enabled: true,
    phase: 'write',
    fn({ state }) {
        var _a;
        const { initial, adjusted, availableSpaces } = state.modifiersData.fit;
        const adaptivePlacement = !!state.modifiersData.adpApplyDirection;
        const content = state.elements.popper;
        const customHeightLimit = (_a = content.dataset) === null || _a === void 0 ? void 0 : _a.height;
        if (initial === 'none' || !adaptivePlacement) {
            content.style.maxHeight = availableSpaces[adjusted] + 'px';
        }
        else if (initial !== 'none' && customHeightLimit) {
            content.style.maxHeight = customHeightLimit + 'px';
        }
    },
};
export const silent = [offset, { name: 'eventListeners', enabled: false }, { name: 'computeStyles', enabled: false }];
//# sourceMappingURL=popper.js.map